import { withStyles } from '@material-ui/core/styles';
import { WbTooltip } from '../WbTooltip';

export const MeshTooltip = withStyles(theme => ({
  tooltip: {
    fontSize: theme.typography.fontSize,
  },
}))(WbTooltip);
